import { render, staticRenderFns } from "./GoalAndStreakModal.vue?vue&type=template&id=d99af7e8&"
import script from "./GoalAndStreakModal.vue?vue&type=script&lang=ts&"
export * from "./GoalAndStreakModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports